module.exports = __webpack_public_path__ + "static/media/24UHCHR12.333e0dd2.jpg";